import api from '../../../services/api';
import type { ApiResponse } from '../../../types/types';

export interface EventTagDefinition {
  id: string;
  label: string;
  shortLabel?: string;
  description?: string;
  type: 'system' | 'manual';
  color: string;
  backgroundColor: string;
  priority: number;
  enabled: boolean;
}

export interface AdminEventTag {
  id: string;
  label: string;
  shortLabel?: string;
  description?: string;
  type: 'system' | 'manual';
  color: string;
  backgroundColor: string;
}

export interface AdminEventWithTags {
  _id: string;
  title: string;
  slug: string;
  startDate?: string;
  endDate?: string;
  coverImage?: string;
  city?: string;
  state?: string;
  manualEventTags?: string[];
  tags?: AdminEventTag[];
}

export const eventTagAdminService = {
  getDefinitions: async () => {
    const response = await api.get<ApiResponse<EventTagDefinition[]>>('/admin/event-tags/definitions');
    return response.data;
  },

  listEvents: async () => {
    const response = await api.get<ApiResponse<AdminEventWithTags[]>>('/admin/event-tags/events');
    return response.data;
  },

  patchEventTags: async (eventId: string, payload: { emAlta?: boolean; manualEventTags?: string[] }) => {
    const response = await api.patch<ApiResponse<AdminEventWithTags>>(
      `/admin/event-tags/events/${eventId}`,
      payload
    );
    return response.data;
  },
};
